import React from 'react';

import { Badge, FieldDirection, type FieldDirectionProps, FieldSearch, type FieldSearchProps } from '@pkg/components';
import { EmojiPickerComboFloating } from '@pkg/components/GlobalSearch/EmojiPickerComboFloating';
import { EmojiPickerWrapper } from '@pkg/components/GlobalSearch/SearchInput/styles';

import { useYatFiltersStore } from '@app/store/zustand';

import {
    FilterAction,
    FilterActionLabel,
    FiltersRowWrapper,
    FlexGroup,
    SearchWrapper,
    StyledFiltersRow,
} from './FiltersRow.style';

export function YatFiltersRow() {
    const {
        filterVisibility,
        setFilterVisibility,
        isSortingDown,
        setIsSortingDown,
        hiddenCount,
        visibleCount,
        filterString,
        setFilterString,
    } = useYatFiltersStore();

    function handleSelectEmoji(selectedEmoji: string) {
        setFilterString((filterString || '') + selectedEmoji);
    }

    const handleSort: FieldDirectionProps['onToggle'] = (newDirection) => {
        setIsSortingDown(newDirection === 'desc');
    };

    const handleChangeInput: FieldSearchProps['onChange'] = (newValue = '') => {
        const stringified = newValue.toString();
        setFilterString(stringified);
    };

    const isHidden = filterVisibility === 'hidden';
    const isVisible = filterVisibility === 'visible';

    const emojiPickerMarkup = (
        <EmojiPickerWrapper>
            <EmojiPickerComboFloating
                onSelectEmoji={handleSelectEmoji}
                autoPlacementOptions={{ allowedPlacements: ['right-start', 'top-end', 'bottom-end'] }}
            />
        </EmojiPickerWrapper>
    );

    return (
        <StyledFiltersRow>
            <FiltersRowWrapper>
                <FlexGroup>
                    <FilterAction
                        pressed={isHidden}
                        onAction={() => setFilterVisibility(isHidden ? undefined : 'hidden')}
                    >
                        <FilterActionLabel>Hidden Yats </FilterActionLabel>
                        {hiddenCount ? <Badge variant="round">{hiddenCount}</Badge> : null}
                    </FilterAction>

                    <FilterAction
                        pressed={isVisible}
                        onAction={() => setFilterVisibility(isVisible ? undefined : 'visible')}
                    >
                        <FilterActionLabel>Visible to everyone</FilterActionLabel>
                        {visibleCount ? <Badge variant="round">{visibleCount}</Badge> : null}
                    </FilterAction>
                </FlexGroup>

                <SearchWrapper>
                    <FieldSearch
                        backdropBlur
                        value={filterString}
                        placeholder="Search for your Yat"
                        suffix={emojiPickerMarkup}
                        onChange={handleChangeInput}
                    />
                </SearchWrapper>

                <FlexGroup $alignEnd>
                    <FieldDirection
                        direction={isSortingDown ? 'desc' : 'asc'}
                        label="Rhythm Score"
                        onToggle={handleSort}
                    />
                </FlexGroup>
            </FiltersRowWrapper>
        </StyledFiltersRow>
    );
}
